import React from 'react';
import './Header.css';

/**
 * DarkNode – global top bar
 * ---------------------------------
 * • Sticks to the top, full-width
 * • AA-contrast text on #121212 background
 * • `rel="noopener noreferrer"` on external links
 * • No client-side routing assumptions
 */
export default function Header() {
  return (
    <header className="dn-header">
      <div className="dn-header__inner">
        {/* Logo */}
        <a
          href="https://www.darknode.io"
          className="dn-header__logo-link"
          aria-label="DarkNode – home"
        >
          <img
            className="dn-header__logo"
            src="https://cdn.prod.website-files.com/64dca07dffef202bc79f0fe8/64dcaf9177aa8d1c0c4c9a24_Logo%402x-p-500.png"
            alt="DarkNode logo"
            width="140"
            height="40"
            loading="lazy"
          />
        </a>

        {/* Primary nav */}
        <nav className="dn-header__nav" aria-label="Primary">
          <ul>
            {/* <li><a href="https://www.darknode.io/#services">Services</a></li>
            <li><a href="https://www.darknode.io/#about-us">About&nbsp;Us</a></li>
            <li><a href="https://www.darknode.io/#contact">Contact</a></li> */}
          </ul>
        </nav>
      </div>
    </header>
  );
}
